import { getSeasonBoundaryDate } from "../../../../shared/utils/get-season-boundary-date";

import { getEndOfDayTimestamp } from "./get-end-of-day-timestamp";

/**
 * Ограничивает timestamp даты статуса операции допустимым диапазоном:
 * не раньше начала сезона (если оно известно) и не позже конца текущего дня.
 *
 * @param candidate - Предлагаемая дата операции (unix timestamp, мс).
 * @param seasonStartedAt - Начало сезона (unix timestamp, мс) или null, если неизвестно.
 * @returns Timestamp не позже конца сегодняшнего дня; не раньше начала сезона, если
 * seasonStartedAt задан — иначе нижняя граница отсутствует. Если seasonStartedAt
 * позже конца сегодняшнего дня (сезон ещё не начался), верхняя граница побеждает
 * нижнюю — возвращённый timestamp может быть раньше seasonStartedAt.
 */
export function clampOperationTimestamp(
  candidate: number,
  seasonStartedAt: number | null
): number {
  const now = new Date();
  const maxTimestamp = getEndOfDayTimestamp(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );
  const minTimestamp =
    getSeasonBoundaryDate(seasonStartedAt ?? undefined, "start")?.getTime() ?? -Infinity;
  return Math.min(Math.max(candidate, minTimestamp), maxTimestamp);
}
